import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditCardDirectivesModule } from 'angular-cc-library';

import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';

// ROUTING MODULE IMPORT
import { PlaygroundRoutingModule } from './playground.routing.module';

// PLAYGROUNG COMPONENT IMPORRTS
import { DevPlaygroundComponent } from './components/dev.playground/dev.playground.component';

// SHARED COMPONENTS MODULE
import { SharedAppModule } from 'app/app.module.shared';

@NgModule({
    imports: [
        CommonModule,
        SharedAppModule,
        PlaygroundRoutingModule,
        DropdownModule,
        TabViewModule,
        CreditCardDirectivesModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        // MODULE CHILD COMPONENTS HERE
        DevPlaygroundComponent,

    ]
})
export class PlaygroundModule { }
